import type { StepWithLifecycleEffectsWithId } from '../../use-cases/tour/util/utils';
import { filterMap } from './filterMap';

export const getTourIds = (steps: Array<StepWithLifecycleEffectsWithId>): string[] => {
  return filterMap(steps, step => step.id);
};
